import React from 'react';
import { StyledVideoControlsPanel } from './VideoControlsPanel.style';

export const VideoControlsPanel = ({ className, children }) => {
  return (
    <StyledVideoControlsPanel className={className} data-testid="VideoControlsPanel">
      {children}
    </StyledVideoControlsPanel>
  );
};